import React, { useState, useEffect } from "react";
import FormLabels from "../../../../../library/custom/formLabel/FormLabels";
import { CURRENT_PHASE_STATUS } from "../../../../../constant/storm-water/constant";
import SelectMenu from "../../../../../library/custom/selectMenu/SelectMenu";
import { InputField } from "../../../../../library/custom/textBox/InputField";
import { Grid } from "@mui/material";
import Checkbox from "../../../../../library/checkbox/checkbox";

const CurrentPhaseProject = (props) => {
  const [projectPhaseAnyChecked, setProjectPhaseAnyChecked] = useState(false);
  const projectPhaseHandler = (
    isChecked,
    statusValue,
    commentValue,
    projectPhaseData
  ) => {
    const updatedStatus = statusValue !== null ? statusValue : 0;

    props?.setSwInspectionCurrentProjectPhase((prevState) => {
      const existingIndex = prevState.findIndex(
        (item) =>
          (item.key || item.optionId) ===
          (projectPhaseData.key || projectPhaseData.optionId)
      );

      if (existingIndex !== -1) {
        const updatedData = [...prevState];
        updatedData[existingIndex] = {
          ...updatedData[existingIndex],
          optionId: projectPhaseData?.key,
          isChecked: isChecked,
          comment: commentValue || "",
          status: updatedStatus,
        };
        return updatedData;
      }

      return prevState;
    });
  };
  useEffect(() => {
    if (props?.swInspectionCurrentProjectPhase) {
      const anyChecked = props?.swInspectionCurrentProjectPhase.some(
        (item) => item.isChecked
      );
      setProjectPhaseAnyChecked(anyChecked);
    }
  }, [props?.swInspectionCurrentProjectPhase]);

  return (
    <>
      <Grid container>
        <Grid item md={12} className="northCarolinaOverride" mt={2}>
          <div className="commonTableBoxNorth">
            <div className="commonTableBoxNorthTitle">
              <FormLabels
                label={"Current Phase of Project"}
                isRequired={true}
              />
            </div>
            <table>
              <tr className="tableHead">
                <th className="sixty">
                  Check ALL applicable box(es) that apply to completed & current
                  phases
                </th>
                <th>Status:</th>
              </tr>
              {props?.swInspectionCurrentProjectPhase?.map((projectPhase) => {
                return (
                  <tr className="tableBody" key={projectPhase?.key}>
                    <td className="projectPhaseLeft">
                      <div className="left">
                        {projectPhase?.value || projectPhase?.optionName}
                      </div>
                      <div className="right">
                        <Checkbox
                          checked={projectPhase?.isChecked}
                          onChange={(e) =>
                            projectPhaseHandler(
                              e.target.checked,
                              projectPhase.status,
                              projectPhase?.comment,
                              projectPhase
                            )
                          }
                          label={""}
                        />
                      </div>
                    </td>
                    <td>
                      <SelectMenu
                        listData={CURRENT_PHASE_STATUS}
                        value={projectPhase.status}
                        placeholder="Please Select"
                        onchangehandler={(e) =>
                          projectPhaseHandler(
                            projectPhase?.isChecked,
                            e.target.value,
                            projectPhase?.comment,
                            projectPhase
                          )
                        }
                      />
                      {projectPhase.status === 3 && (
                        <InputField
                          isRequired={false}
                          type="text"
                          placeholder={"Enter Here..."}
                          value={projectPhase.comment || ""}
                          onChange={(e) =>
                            projectPhaseHandler(
                              projectPhase?.isChecked,
                              projectPhase.status,
                              e.target.value,
                              projectPhase
                            )
                          }
                        />
                      )}
                    </td>
                  </tr>
                );
              })}
            </table>
          </div>
          <Grid md={12} item mb={2}>
            {props?.projectPhaseError && !projectPhaseAnyChecked && (
              <p className="error">
                Please select at least one current project phase.
              </p>
            )}
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};
export default CurrentPhaseProject;
